import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Chip, Stack } from "@mui/material";
import { Warning, ErrorOutline } from "@mui/icons-material";
import { Dialog } from "../../../../components/others/Dialog";

export const DianErrorsDialog = ({ dianResponse, onClose }) => {
  const { t } = useTranslation();
  if (!dianResponse) return null;

  return(
    dianResponse &&
      <Dialog
        openDialog={true}
        widthDialog="md"
        styleDialog={{ borderRadius: 16, padding: "10px" }}
        title={dianResponse.StatusMessage}
        styleTitle={{ fontWeight: "bold", color: "#d32f2f", fontSize: "1.2rem" }}
        content={
          <Stack spacing={2}>
            {dianResponse?.ErrorMessage?.map((err, idx) => {
              const isRejection = err.includes("Rechazo");
              return (
                <Stack
                  key={idx}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{
                    padding: "10px",
                    borderRadius: "12px",
                    backgroundColor: isRejection ? "#ffebee" : "#fff8e1",
                    border: `1px solid ${isRejection ? "#f44336" : "#ff9800"}`,
                  }}
                >
                  {isRejection ? ( <ErrorOutline sx={{ color: "#f44336" }} /> ) : ( <Warning sx={{ color: "#ff9800" }} /> )}
                  <span style={{ color: isRejection ? "#b71c1c" : "#e65100" }}>{err}</span>
                </Stack>
              );
            })}
          </Stack>
        }
        styleContent={{ padding: "16px" }}
        actions={
          <Button onClick={onClose} variant="contained" sx={{ borderRadius: "12px", backgroundColor: "#1976d2" }}>{t('close')}</Button>
        }
        styleActions={{ justifyContent: "flex-end", padding: "12px" }}
      />
  )
};
